import { initializeApp } from "@firebase/app";
const firebase = initializeApp({
  apiKey: "AIzaSyDSIGTzzi0AGhuYLzQK0inOXtVnTIr_KCE",
  authDomain: "whatsapp-21858.firebaseapp.com",
  projectId: "whatsapp-21858",
  storageBucket: "whatsapp-21858.appspot.com",
  messagingSenderId: "411738670461",
  appId: "1:411738670461:web:72cc2aeb7944e0b8a4f814",
  measurementId: "G-C7F41FGJ6H",
});


export default firebase;